import { Tooltip } from "@material-ui/core";
import { IconButton } from '@mui/material';
import { ReactComponent as CopyIconGray } from 'assets/icons/CopyIconGray.svg';
import { ReactComponent as ExportIcon } from 'assets/icons/Export.svg';
import { ReactComponent as Share } from 'assets/icons/ShareClass.svg';
import { ReactComponent as WarningIcon } from 'assets/icons/WarningIcon.svg';

import Action from 'components/ActionPopOver';
import { AlertMessage } from "components/AlertMessage";
import { formatDate } from "helper/dateFormat";
import { numberFormat } from "helper/numberFormat";
import React, { useEffect } from 'react';
import { CopyToClipboard } from "react-copy-to-clipboard";
import { useHistory } from 'react-router-dom';
import './EventDrawer.scss';
import {
  Button,
  Buttons,
  Contant,
  Dates,
  Description,
  EventType,
  Header,
  PreviewIcon,
  PriceSection, Total,
  VirtualAddress,
  Worning,
  Wrapper
} from './Theme';
import { fontConfig } from "theme/fontConfig";

const EventDrawer = ({
  drawerData,
  setIsDrawerOpen,
  setConfirmDialog,
  setArchiveStatus,
  setDeleteClassId,
  setArchiveClassId,
  onExport,
  setExportAllTable,
  exportAllTable,
  toggle,
}) => {
  const history = useHistory();
  const registrationEnds = drawerData?.eventEndDate ? formatDate({date:drawerData?.eventEndDate, formatType: "defaultWithUTC"}) :
  drawerData?.alwaysAvailable ? 'Always available':''
  const dates = [{title:"Registration Starts",
  content:formatDate({date:drawerData?.eventStartDate, formatType: "defaultWithUTC"})},
                
  {title:"Registration ends",content:registrationEnds},

  {title:"Form",content:"Preview Event",icon:<PreviewIcon/>, onClick: () => {
    previewEvent();
  }}]

  const organization = localStorage.getItem('organization')
    ? JSON.parse(localStorage.getItem('organization'))
    : null;
  const orgKey = organization?.orgkey;
  const mainUrl = window.location.origin;
  const checkDomain =
    mainUrl === 'https://admin.eztmpl.dev' ||
    mainUrl === 'http://localhost:3000'
      ? `https://shalom.eztmpl.dev/events/${drawerData?._id}`
      : mainUrl === 'https://admin.eztmpl.com'
      ? `https://demo.eztmpl.com/events/${drawerData?._id}`
      : mainUrl === 'https://admin.easyshul.com'
      ? `https://${orgKey}.easyshul.com/events/${drawerData?._id}`
      : null;

    const [copyLinkSuccess, setCopyLinkSuccess] = React.useState(false);

    useEffect(() => {
      const timer = setTimeout(() => {
        setCopyLinkSuccess(false);
      }, 2000);
      return () => clearTimeout(timer);
    }, [copyLinkSuccess]);

  const previewEvent = () => {
    window.open(checkDomain, '_blank');
  };

const calculateProductPrice = (price) => {
  if((price?.type?.toLowerCase() === 'optional' || price?.type?.toLowerCase() === 'onregistration') && price?.variant) {
    const amounts = Object.values(price?.variantInfo).map(product => product.amount || 0);
    const minAmount = Math.min(...amounts);
    const maxAmount = Math.max(...amounts);
    return `${numberFormat({number:+minAmount, decimal: 2, style: "currency"})} - ${numberFormat({number:+maxAmount, decimal: 2, style: "currency"})}`;
  } else {
    return `${numberFormat({number:+price?.amount, decimal: 2, style: "currency"})}`;
  }
}


  return (
    <Wrapper>
      {copyLinkSuccess && (
        <div className="copy-alert">
          <AlertMessage type="success" content="URL Copied Successfully" />
        </div>
      )}
      <Contant>
        <Header>
        <span>{drawerData?.eventName}</span>        
        <div className="popover__drawer">
          <IconButton className="p-0 px-2">
            <Action
              onEditClick={
                () =>history.push(`/edit-event/${drawerData?._id}`)
              }
              onArchiveClick={
                toggle
                  ? () => {
                      setArchiveClassId([drawerData?._id]);
                      setConfirmDialog(true);
                      setArchiveStatus(true);
                    }
                  : undefined
              }
              onClassDeleteClick={() => {
                setDeleteClassId(drawerData?._id);
                setConfirmDialog(true);
              }}
              style={{
                minHeight: "50px",
              }}
              action={'eventDrawer'}
            />
          </IconButton>
        </div>
      </Header>
      <Dates>
        {dates.map((item)=>(
          <div 
            onClick={item?.onClick}
            style={{cursor:item?.title ==="Form" ? 'pointer':'default'}}
          >
          <span>{item.title}</span>
          <p>{item.content}{item?.icon}</p>
        </div>
        ))}
      
      </Dates>
      <EventType>
        <div>
          <span>{drawerData?.eventDetails?.eventType}</span>
          <span>Event type</span>
        </div>
        <div>
          <div style={{ display: 'flex', flexDirection: 'row', gap: '8px', alignItems: 'flex-start', width: 'auto' }}>
            <span style={{ whiteSpace: 'nowrap', opacity: 0.7, fontSize: '12px', fontWeight: 400, flexShrink: 0 }}>Date</span>
            {drawerData?.multiEvents && drawerData?.multiEventsDates?.length > 0 ? (() => {
              const first = drawerData.multiEventsDates[0];
              const remaining = drawerData.multiEventsDates.slice(1);
              const tooltipContent = (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', padding: '4px 0' }}>
                  {remaining.map((d, i) => (
                    <div key={i} style={{ fontSize: '11px', fontFamily: fontConfig.EventsEventDrawerTextFont.family, whiteSpace: 'nowrap' }}>
                      {d.label && <strong>{d.label} </strong>}
                      {d.eventDate ? formatDate({ date: d.eventDate, formatType: 'defaultWithTimeUTC' }) : ''}
                    </div>
                  ))}
                </div>
              );
              return (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '2px', alignItems: 'flex-start' }}>
                  {first?.label && <span style={{ fontSize: '12px', fontWeight: 600, paddingLeft: '8px' }}>{first.label}</span>}
                  <span style={{ whiteSpace: 'nowrap' }}>{first?.eventDate ? formatDate({ date: first.eventDate, formatType: 'defaultWithTimeUTC' }) : ''}</span>
                  {remaining.length > 0 && (
                    <Tooltip title={tooltipContent} placement="right" arrow={false}>
                      <span style={{ fontSize: '11px', fontWeight: 600, color: '#2555EF', cursor: 'pointer', paddingLeft: '8px' }}>
                        + {remaining.length} more
                      </span>
                    </Tooltip>
                  )}
                </div>
              );
            })() : (
              <span>{drawerData?.date ? formatDate({ date: drawerData?.date, formatType: 'defaultWithTimeUTC' }) : ''}</span>
            )}
          </div>
          <div role="button" style={{position:'absolute', right:'0px'}}>
          <Tooltip title="Copy Link">
            <CopyToClipboard text={checkDomain}>
              <CopyIconGray onClick={(e) => {
                e.stopPropagation();
                setCopyLinkSuccess(true);
              }} />
            </CopyToClipboard>
          </Tooltip>  
          </div>
          <VirtualAddress>
            <span>{drawerData?.eventDetails?.eventType?.toLowerCase() === "online" ? "Virtual Address" : "Location"}</span>
            {drawerData?.eventDetails?.eventAddress?.formattedAddress}
          </VirtualAddress>
          
        </div>
      </EventType>
      <Buttons>
          <Button onClick={()=>setExportAllTable(!exportAllTable)}><ExportIcon/><span>Export Event Data</span></Button>
          {!drawerData?.displayOnly && (
            <Button
              onClick={() => {
                previewEvent();
              }}
            ><Share/><span>Share Registration Link</span></Button>
          )}
      </Buttons>
      <Description>
        <span>Description</span>
        {drawerData?.description?.replace(/&lt;/g, '<') !== '<p></p>\n' && (
          <div className="drawer_description">
            <p
              dangerouslySetInnerHTML={{
                __html: drawerData?.description?.replace(/&lt;/g, '<'),
              }}
            ></p>
          </div>
        )}
      </Description>
      

      <Worning>
      <WarningIcon/><span>{drawerData?.allowNonMembers ? "Non" : "Only"} members are eligible to register for this event</span>
      </Worning>
     <hr/>
      
     
     <PriceSection>
     {drawerData?.eventPricing?.prices?.length > 0 &&
      drawerData?.eventPricing?.prices?.map((price) => (
        <div >
          <p>{price?.title}
          {(price?.type?.toLowerCase() === 'optional' || price?.type?.toLowerCase() === 'addons') && <span className="price_section-optional">(Add-ons)</span>}
          </p>
          <span>
            {calculateProductPrice(price)}
          </span>
        </div>
      ))}

   
     </PriceSection>

      </Contant>

    </Wrapper>
   
  );
};

export default EventDrawer;
